// extracted by mini-css-extract-plugin
export default {"wrapper":"StoriesBranch_wrapper__YV2xs","no-card":"StoriesBranch_no-card__LiK09","info-wrapper":"StoriesBranch_info-wrapper__JkSqd","story-list":"StoriesBranch_story-list__CsG-Y"};